import '../styles/index.css'

import $ from 'jquery';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'simplebar/dist/simplebar.css';
import 'normalize.css/normalize.css';

import 'imports-loader?jQuery=jquery!owl.carousel';
import SimpleBar from 'simplebar'
import Vote from './vote'
import Currency from './currency'



const dir = "rtl";


((
	( $ ) => {

		$('.slider').owlCarousel({
			items:1,
			autoplay:true,
			nav:true,
			navText:[],
			rtl: (dir === "rtl"),
			loop:true
		});

		$('.main-block.scrollbar .main-block--content').each((i,el) => {
			new SimpleBar(el, {  autoHide: true });
		});

		const tabs = (selector) => {
			$(selector).each((index,element) => {
				const parent = $(element);
				const link = parent.find(`${selector}--link`);
				link.on('click',function(e){
					e.preventDefault();
					const me = $(this);
					if(me.hasClass('active')){
						return false;
					}
					parent.find(`${selector}--link.active`).removeClass('active');
					me.addClass('active');
					parent.find(`${selector}--pane.active`).removeClass('active').hide();
					let id = me.attr('href');
					$(id).stop().fadeIn('slow').addClass('active');
				});
			})
		}

		tabs('.tabs1');

		tabs('.tabs2');

		new Vote('.voting');

		new Currency('.currency');

	}
)( jQuery ));



// WEBPACK FOOTER //
// ./src/scripts/index.js